import { render, staticRenderFns } from "./scroll-to-top.vue?vue&type=template&id=7b34de98&scoped=true&"
import script from "./scroll-to-top.vue?vue&type=script&lang=js&"
export * from "./scroll-to-top.vue?vue&type=script&lang=js&"
import style0 from "./scroll-to-top.vue?vue&type=style&index=0&id=7b34de98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b34de98",
  null
  
)

export default component.exports